import { render, staticRenderFns } from "./ProfileDraft.vue?vue&type=template&id=224e13b5&"
import script from "./ProfileDraft.vue?vue&type=script&lang=js&"
export * from "./ProfileDraft.vue?vue&type=script&lang=js&"
import style0 from "./ProfileDraft.vue?vue&type=style&index=0&id=224e13b5&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports